export type NavigationSliceInitialState = {
  routes: NavigationRoutes;
  initialRoute: NavigationRoute;
  wasEditorPopstate: boolean;
  configuredPathHistory: string[];
};

export type NavigationRouteMap = {
  catalogSelector: string;
  cart: string;
  projects: string;
  editor: string;
  priceTool: string;
};

export type NavigationRoute = keyof NavigationRouteMap;
export type NavigationRoutes = { [Property in NavigationRoute]: boolean };

export type InitializeNavigationPayload = {
  [Property in NavigationRoute]?: boolean;
};

export type NavigationHistoryState = { route: NavigationRoute };
